/* Native predictive product search; brand destinations come from approved navigation. */
(() => {
  const cache = new Map();
  const normalize = value => value.toLowerCase().trim().replace(/\s+/g, ' ');
  // Ignore punctuation differences such as straight/curly inch marks when ranking titles.
  const titleKey = value => normalize(value).replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const skuKey = value => normalize(value).replace(/\s+/g, '');
  function relevance(title, skus, query) {
    const key = titleKey(query), name = titleKey(title);
    if (skus.some(sku => sku && skuKey(sku) === skuKey(query))) return 400;
    if (name === key) return 300;
    if (key && name.startsWith(key)) return 200;
    const words = key.split(' ').filter(Boolean), names = name.split(' ');
    if (words.length && words.every(word => names.includes(word))) return 100;
    return 0;
  }
  const brandKey = value => {
    const key = titleKey(value);
    return key === 'aog' ? 'american outdoor grill' : key;
  };
  function brandRelevance(vendor, query) {
    const brand = brandKey(vendor), key = brandKey(query);
    return key && (brand === key || brand.startsWith(key + ' ')) ? 250 : 0;
  }
  function targetedQuery(query) {
    const words = titleKey(query).split(' ').filter(Boolean).slice(0, 16);
    const escaped = query.replace(/([\\":()])/g, '\\$1');
    return '(' + words.map(word => 'title:' + word + '*').join(' AND ') + ') OR variants.sku:"' + escaped + '" OR vendor:"' + brandKey(query) + '"';
  }
  document.querySelectorAll('[data-predictive-search]').forEach(form => {
    if (form.dataset.predictiveReady) return;
    form.dataset.predictiveReady = 'true';
    const input = form.querySelector('input[name="q"]');
    const panel = form.querySelector('[data-suggestions]');
    const brands = form.querySelector('[data-brand-suggestions]');
    const products = form.querySelector('[data-product-suggestions]');
    const status = form.querySelector('[data-search-status]');
    const all = form.querySelector('[data-search-all]');
    let timer, controller, generation = 0;
    function close() {
      clearTimeout(timer); controller?.abort(); generation++;
      panel.hidden = true; input.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('aria-busy'); status.textContent = '';
    }
    function show() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function brandMatches(q) {
      const found = new Map();
      document.querySelectorAll('ho-header [data-nav-item]').forEach(item => {
        const label = item.previousElementSibling?.matches('.ho-department-link') ? item.previousElementSibling : item.querySelector('summary');
        if (normalize(label?.textContent || '') !== normalize(form.dataset.brandsLabel)) return;
        item.querySelectorAll('.ho-submenu li a[href]').forEach(link => {
          const name = link.textContent.trim();
          if ((normalize(name).includes(q) || (name === 'American Outdoor Grill' && /^aog$/.test(q))) && new URL(link.href).origin === location.origin) found.set(link.href, name);
        });
      });
      // Registered brand shops also work before they are added to the navigation menu.
      const registered = form.closest('ho-header')?.querySelector('[data-search-brand-logos]')?.content;
      registered?.querySelectorAll('img[data-search-brand-name]').forEach(logo => {
        const name = logo.dataset.searchBrandName;
        const url = new URL(logo.dataset.brandUrl, location.origin);
        if (normalize(name).includes(q) && url.origin === location.origin) found.set(url.href, name);
      });
      brands.replaceChildren();
      if (found.size) {
        const heading = document.createElement('p'); heading.textContent = form.dataset.brandsLabel; brands.append(heading);
        found.forEach((name, href) => {
          const a = document.createElement('a'); a.href = href;
          // Prefer the actual homepage brand image, including merchant overrides.
          const homeCard = [...document.querySelectorAll('#shop-brands a.ho-editorial-card')].find(card => card.href === href);
          const fallback = form.closest('ho-header')?.querySelector('[data-search-brand-logos]')?.content;
          const logo = homeCard?.querySelector('.ho-brand-identity img') || [...(fallback?.querySelectorAll('img') || [])].find(img => new URL(img.dataset.brandUrl, location.origin).href === href);
          if (logo) {
            const image = logo.cloneNode(true); image.removeAttribute('id'); image.removeAttribute('class'); image.alt = ''; image.loading = 'eager';
            image.addEventListener('error', () => { image.remove(); a.querySelector('span')?.classList.remove('visually-hidden'); }, {once:true}); a.append(image);
          }
          const label = document.createElement('span'); label.textContent = name; if (logo) label.className = 'visually-hidden'; a.append(label); brands.append(a);
        });
      }
    }
    function render(markup) {
      const query = input.value.trim();
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const cards = doc.querySelectorAll('[data-predictive-products] .ho-product-card');
      products.replaceChildren();
      const seen = new Set();
      const ranked = [...cards].map((card, index) => {
        const candidate = card.closest('[data-search-candidate]');
        const title = candidate?.dataset.searchTitle || card.querySelector('h3')?.textContent || '';
        const skus = (candidate?.dataset.searchVariants || '').split('\n');
        const productScore = relevance(title, skus, query);
        const score = Math.max(productScore, relevance(card.querySelector('h3')?.textContent || '', [], query), brandRelevance(candidate?.dataset.searchVendor || '', query));
        if (productScore >= 300) card = candidate?.querySelector('[data-search-exact-card]')?.content.querySelector('.ho-product-card') || card;
        const variant = [...(candidate?.querySelector('[data-search-variant-links]')?.content.querySelectorAll('[data-sku]') || [])]
          .find(link => skuKey(link.dataset.sku) === skuKey(query));
        if (variant) card.setAttribute('href', variant.getAttribute('href'));
        return {card, index, score};
      }).sort((a, b) => b.score - a.score || a.index - b.index);
      ranked.forEach(({card}) => {
        const key = card.dataset.familyHandle || card.getAttribute('href');
        if (seen.has(key) || products.children.length >= 8) return;
        seen.add(key); products.append(card);
      });
      status.textContent = (products.children.length + brands.querySelectorAll('a').length) + ' results';
    }
    function update() {
      clearTimeout(timer); controller?.abort(); const current = ++generation;
      const q = normalize(input.value);
      products.replaceChildren(); panel.removeAttribute('aria-busy'); status.textContent = '';
      if (q.length < 2) { close(); return; }
      brandMatches(q);
      const url = new URL(form.action); url.searchParams.set('q', input.value.trim()); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); all.href = url.href;
      show();
      if (cache.has(q)) { render(cache.get(q)); return; }
      timer = setTimeout(async () => {
        controller = new AbortController(); panel.setAttribute('aria-busy', 'true');
        const endpoint = new URL((window.Shopify?.routes?.root || '/') + 'search/suggest', location.origin);
        endpoint.searchParams.set('q', q); endpoint.searchParams.set('section_id', 'predictive-search');
        endpoint.searchParams.set('resources[type]', 'product'); endpoint.searchParams.set('resources[limit]', '8');
        endpoint.searchParams.set('resources[options][fields]', 'title,product_type,vendor,variants.title,variants.sku');
        try {
          // Brand-only Primo searches lead with grills, not native title relevance (e.g. apparel).
          if (/^primo(?: ceramic)?(?: grills?)?$/.test(q)) {
            const grillURL = new URL('/collections/primo-grills', location.origin);
            grillURL.searchParams.set('view', 'top-discovery-json');
            const response = await fetch(grillURL, {signal: controller.signal});
            if (!response.ok) throw new Error('Primo grills unavailable');
            const data = await response.json();
            if (!Array.isArray(data.items)) throw new Error('Invalid Primo grill response');
            const markup = '<div data-predictive-products>' + data.items.slice(0, 8).map(row => row.html).join('') + '</div>';
            if (current !== generation) return;
            cache.set(q, markup); render(markup); return;
          }
          const exact = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
          exact.searchParams.set('view', 'exact-candidates');
          exact.searchParams.set('type', 'product');
          exact.searchParams.set('q', targetedQuery(q));
          const requests = [endpoint];
          if (titleKey(q)) requests.push(exact);
          const responses = await Promise.allSettled(requests.map(async url => {
            const response = await fetch(url, {signal: controller.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const html = await response.text();
            if (!html.includes('data-predictive-products')) throw new Error('Invalid search response');
            return html;
          }));
          const markup = responses.filter(result => result.status === 'fulfilled').map(result => result.value).join('');
          if (!markup) throw new Error('Search unavailable');
          if (current !== generation) return;
          cache.set(q, markup); if (cache.size > 30) cache.delete(cache.keys().next().value);
          render(markup);
        } catch (error) {
          // Keep brand links and the normal search destination usable on network failure.
          if (error.name !== 'AbortError' && current === generation) products.replaceChildren();
        } finally { if (current === generation) panel.removeAttribute('aria-busy'); }
      }, 200);
    }
    input.addEventListener('input', event => { if (!event.isComposing) update(); });
    input.addEventListener('compositionend', update);
    input.addEventListener('focus', () => { if (panel.hidden) update(); });
    form.addEventListener('submit', close);
    form.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); event.stopPropagation(); input.focus(); close(); return; }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || panel.hidden) return;
      const links = [...panel.querySelectorAll('a[href]')]; if (!links.length) return;
      event.preventDefault(); const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowUp' && index === 0) input.focus();
      else links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
    });
    form.addEventListener('focusout', () => { setTimeout(() => { if (!form.contains(document.activeElement)) close(); }, 0); });
    document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) close(); });
    form.closest('dialog')?.addEventListener('close', close);
  });
})();
